<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{ $t('form.create', { item: formTitle }) }}</strong>
        </b-card-header>
        <b-card-body>
            <Form
                :isEdit="false"
                :objectiveId="objectiveId"
                @onSubmit="onSubmit"
                v-if="isAllowedToCreateTargets()"
                :can-create="canCreate"
                :can-create-library-target="canCreateLibraryTarget"
                :current-event-permissions="this.permissions.current_event_permissions.goals"
                :moduleForm="'target'"
                :isLibraryTarget="isLibraryTarget"
                :defaultOwnerId="defaultOwnerId"
            />
            <div v-else>
                <b-alert show variant="warning" class="mt-3">
                    <i class="fa fa-warning"></i>
                    {{
                        $t('notification.permissions.createDenied', {
                            item: formTitle,
                        })
                    }}
                </b-alert>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import mapperFormToApi from './mappers/mapperFormToApi'
import notification, { success, danger } from '@/lib/notification'
import { getUserPermissions } from '@/services/user-permissions'
import { userPermissionsMixin } from '@/mixins'
import Form from '@/views/target/components/form'
import { getParam } from '@/lib/url'

notification.init()

export default {
    name: 'New',
    mixins: [userPermissionsMixin],
    components: {
        Form,
    },
    props: ['objective'],
    data() {
        return {
            permissions: {},
            objectiveId: null,
            isLibraryTarget: null,
            defaultOwnerId: null,
        }
    },
    created() {
        this.permissions = getUserPermissions()
        if (this.isProfileRequisition && !this.userHasRolePermission) {
            this.permissions.current_event_permissions.goals = this.$store.state.filters.currentEventPermissions.goals
        }
        this.defaultOwnerId = this.$route.query.ownerId
        this.isLibraryTarget = this.$route.query.libraryTarget ? true : false
        this.formTitle = this.isLibraryTarget ? i18n.t('targets.libraryTarget') : i18n.t('targets.target')
    },
    mounted() {
        this.isAllowedToCreateTargets()
        this.objectiveId = getParam('objectiveId', this)
    },
    methods: {
        isAllowedToCreateTargets() {
            if (this.isLibraryTarget) {
                return this.isAllowedToCreateLibraryTarget()
            }
            const { create } = this.permissions.current_event_permissions.goals.consolidated
            let isAllowed = this.permissions.modules.has_goal && (this.permissions.is_admin || create)

            if (!isAllowed) {
                Swal({
                    type: 'warning',
                    title: i18n.t('notification.permissions.createDenied', {
                        item: i18n.t('targets.target'),
                    }),
                })
            }
            return isAllowed
        },
        isAllowedToCreateLibraryTarget() {
            const { create_library_goal: createLibraryGoal } =
                this.permissions.current_event_permissions.goals.consolidated

            let isAllowed = this.permissions.modules.has_goal && (this.permissions.is_admin || createLibraryGoal)

            if (!isAllowed) {
                Swal({
                    type: 'warning',
                    title: i18n.t('notification.permissions.createDenied', {
                        item: i18n.t('targets.libraryTarget'),
                    }),
                })
            }
            return isAllowed
        },
        goBack() {
            this.$router.back()
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.post('/goals', mapperFormToApi(form))
                .then(() => {
                    onReset()
                    this.notificationTargetCreatedSuccessfully()
                    this.goBack()
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationTargetCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('targets.target'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
    computed: {
        isProfileRequisition() {
            return Object.keys(this.$store.state.filters.currentEventPermissions).length
        },
        userHasRolePermission() {
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_target_master']
            const currentUser = this.$store.state.currentUser.user
            const rolesPermission = this.userHasPermission(currentUser, availableRoles, [])
            return rolesPermission
        },
        canCreate() {
            return this.permissions ? this.permissions.current_event_permissions.goals.consolidated.create : true
        },
        canCreateLibraryTarget() {
            return this.permissions
                ? this.permissions.current_event_permissions.goals.consolidated.create_library_goal
                : true
        },
    },
}
</script>
